// @ts-nocheck
/**
 * ツインキー装備セットボーナス定義
 *
 * 設計書: twin_key_phase2_design.md
 * 参照: alchemy_system.md
 */

import { EQUIPMENT_EFFECT_TYPES } from './equipmentData';

/**
 * セットボーナス定義
 */
export const EQUIPMENT_SETS = {
  // 炎セット
  flame_set: {
    id: 'flame_set',
    name: '炎竜セット',
    description: '炎の力を纏う装備セット',
    pieces: ['flame_blade', 'flame_armor', 'flame_amulet'],
    bonuses: {
      2: {
        name: '炎の加護',
        description: '炎属性ダメージ+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '炎', value: 0.15 },
        ],
      },
      3: {
        name: '炎竜の力',
        description: '攻撃時10%で火傷付与、攻撃力+20%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.ATK_PERCENT, value: 0.20 },
          { type: EQUIPMENT_EFFECT_TYPES.STATUS_INFLICT, statusType: 'BURN', value: 0.10 },
        ],
      },
    },
  },

  // 氷セット
  frost_set: {
    id: 'frost_set',
    name: '氷結セット',
    description: '凍てつく力を宿す装備セット',
    pieces: ['frost_staff', 'frost_robe', 'frost_orb'],
    bonuses: {
      2: {
        name: '氷の加護',
        description: '水属性ダメージ+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '水', value: 0.15 },
        ],
      },
      3: {
        name: '絶対零度',
        description: '攻撃時15%で凍結付与、スキル威力+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.SKILL_POWER, value: 0.15 },
          { type: EQUIPMENT_EFFECT_TYPES.STATUS_INFLICT, statusType: 'FREEZE', value: 0.15 },
        ],
      },
    },
  },

  // 竜セット
  dragon_set: {
    id: 'dragon_set',
    name: '竜王セット',
    description: '竜王の力を宿す装備セット',
    pieces: ['dragon_fang', 'dragon_scale', 'dragon_heart'],
    bonuses: {
      2: {
        name: '竜の血',
        description: 'HP+15%、クリティカル率+10%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.HP_PERCENT, value: 0.15 },
          { type: EQUIPMENT_EFFECT_TYPES.CRIT_RATE, value: 0.10 },
        ],
      },
      3: {
        name: '竜王の威光',
        description: 'クリティカルダメージ+30%、与ダメージ+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.CRIT_DMG, value: 0.30 },
          { type: EQUIPMENT_EFFECT_TYPES.DAMAGE_BONUS, value: 0.15 },
        ],
      },
    },
  },

  // 光セット
  light_set: {
    id: 'light_set',
    name: '聖光セット',
    description: '聖なる光の装備セット',
    pieces: ['holy_sword', 'holy_armor', 'holy_ring'],
    bonuses: {
      2: {
        name: '聖なる加護',
        description: '光属性ダメージ+15%、HP回復効果+20%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '光', value: 0.15 },
        ],
      },
      3: {
        name: '聖騎士の誓い',
        description: '味方への回復効果+30%、被ダメージ-10%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.DAMAGE_REDUCE, value: 0.10 },
        ],
      },
    },
  },

  // 闇セット
  dark_set: {
    id: 'dark_set',
    name: '深淵セット',
    description: '闇の力を宿す装備セット',
    pieces: ['void_blade', 'void_cloak', 'void_gem'],
    bonuses: {
      2: {
        name: '闇の抱擁',
        description: '闇属性ダメージ+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.ATTRIBUTE_BONUS, attribute: '闇', value: 0.15 },
        ],
      },
      3: {
        name: '深淵の支配',
        description: '与ダメージの15%を吸収、呪い付与確率+15%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.LIFESTEAL, value: 0.15 },
          { type: EQUIPMENT_EFFECT_TYPES.STATUS_INFLICT, statusType: 'CURSE', value: 0.15 },
        ],
      },
    },
  },

  // 速攻セット
  swift_set: {
    id: 'swift_set',
    name: '疾風セット',
    description: '素早さを極めた装備セット',
    pieces: ['swift_dagger', 'swift_garb', 'swift_boots'],
    bonuses: {
      2: {
        name: '疾風の加護',
        description: '速度+30',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.SPD_FLAT, value: 30 },
        ],
      },
      3: {
        name: '神速',
        description: '速度+50、20%で2回行動',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.SPD_FLAT, value: 50 },
        ],
        special: { type: 'EXTRA_ACTION', probability: 0.20 },
      },
    },
  },

  // 耐久セット
  guardian_set: {
    id: 'guardian_set',
    name: '守護者セット',
    description: '鉄壁の守りを誇る装備セット',
    pieces: ['guardian_shield', 'guardian_plate', 'guardian_amulet'],
    bonuses: {
      2: {
        name: '守護の加護',
        description: 'HP+20%、防御+20',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.HP_PERCENT, value: 0.20 },
          { type: EQUIPMENT_EFFECT_TYPES.DEF_FLAT, value: 20 },
        ],
      },
      3: {
        name: '鉄壁',
        description: '被ダメージ-20%、状態異常耐性+30%',
        effects: [
          { type: EQUIPMENT_EFFECT_TYPES.DAMAGE_REDUCE, value: 0.20 },
          { type: EQUIPMENT_EFFECT_TYPES.STATUS_RESIST, value: 0.30 },
        ],
      },
    },
  },
};

/**
 * セットボーナス計算
 *
 * @param {Array<string>} equippedSetIds - 装備しているアイテムのセットID一覧
 * @returns {Array<{ setId: string, pieces: number, bonuses: Array<Object> }>}
 */
export const calculateSetBonuses = (equippedSetIds) => {
  // セットIDごとにカウント
  const setCounts = {};
  for (const setId of equippedSetIds) {
    if (setId) {
      setCounts[setId] = (setCounts[setId] || 0) + 1;
    }
  }

  // 有効なセットボーナスを収集
  const activeBonuses = [];

  for (const [setId, count] of Object.entries(setCounts)) {
    const set = EQUIPMENT_SETS[setId];
    if (!set) continue;

    const bonuses = [];

    // 2セット効果
    if (count >= 2 && set.bonuses[2]) {
      bonuses.push({
        threshold: 2,
        ...set.bonuses[2],
      });
    }

    // 3セット効果
    if (count >= 3 && set.bonuses[3]) {
      bonuses.push({
        threshold: 3,
        ...set.bonuses[3],
      });
    }

    if (bonuses.length > 0) {
      activeBonuses.push({
        setId,
        setName: set.name,
        pieces: count,
        bonuses,
      });
    }
  }

  return activeBonuses;
};

/**
 * セットボーナスから全効果を抽出
 *
 * @param {Array<Object>} activeBonuses - calculateSetBonusesの結果
 * @returns {Array<Object>} 効果一覧
 */
export const extractSetBonusEffects = (activeBonuses) => {
  const effects = [];

  for (const bonus of activeBonuses) {
    for (const b of bonus.bonuses) {
      effects.push(...(b.effects || []));
    }
  }

  return effects;
};

/**
 * ヘルパー関数: セットデータ取得
 */
export const getSetData = (setId) => EQUIPMENT_SETS[setId] || null;

/**
 * ヘルパー関数: セット一覧取得
 */
export const getAllSets = () => Object.values(EQUIPMENT_SETS);
